import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { ApiDataService } from "@services/http/ApiDataService";
import { ModuleType } from "@enums/ModuleType";
import { PeriodicNotificationModel } from "../models/periodicNotificationModel";

@Injectable()
export class PeriodicNotificationService extends ApiDataService {
    constructor() {
        super("periodicnotifications");
    }

    getNotifications(module: ModuleType): Observable<PeriodicNotificationModel[]> {
        const url = "?module=" + module;
        return this.get<PeriodicNotificationModel[]>(url);
    }

    getOrganizations() {
        const url = "/organizations";
        return this.get<any[]>(url);
    }
}
